module.exports = __webpack_public_path__ + "static/media/login-bg3.1088bfd0.png";